import React from 'react';
import { Spinner } from 'react-bootstrap';

import './LoadingPage.scss';

function LoadingPage(props) {
    return (
        <div className='yoboycup-loading-page'>
            <Spinner animation='border' color='#1B8617' />
        </div>
    );
}

export default LoadingPage;